//frontend\src\lib\api.js
import axios from "axios";
import { tenantHeaders } from "./tenant.js";

const BASE = (import.meta.env.VITE_API_URL || "").replace(/\/+$/, "");

// Si BASE termina en /api -> no agregamos prefijo
// Si BASE NO termina en /api -> usamos /api
export const API_PREFIX = BASE.endsWith("/api") ? "" : "/api";

// opcional, pero recomendado: exportar un cliente axios único
export const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const headers = tenantHeaders();
  config.headers = config.headers || {};
  config.headers["x-tenant"] = config.headers["x-tenant"] || headers["x-tenant"];
  config.headers["x-tenant-slug"] = config.headers["x-tenant-slug"] || headers["x-tenant-slug"];
  return config;
});
